const map = {
	"./en/Clients.json": [
		9189,
		[
			9189
		]
	],
	"./en/Document.json": [
		1734,
		[
			1734
		]
	],
	"./en/FileNavigator.json": [
		8710,
		[
			8710
		]
	],
	"./en/ImageEditor.json": [
		4121,
		[
			4121
		]
	],
	"./en/OffCanvasCodeEditor.json": [
		72,
		[
			72
		]
	],
	"./en/Proposal.json": [
		733,
		[
			733
		]
	],
	"./en/Settings.json": [
		4734,
		[
			4734
		]
	],
	"./en/Tariff.json": [
		9673,
		[
			9673
		]
	],
	"./en/TariffFAQ.json": [
		4435,
		[
			4435
		]
	],
	"./en/TemplateValueKeys.json": [
		6538,
		[
			6538
		]
	],
	"./en/TextFileEditor.json": [
		1543,
		[
			1543
		]
	],
	"./en/common.json": [
		9802,
		[
			9802
		]
	],
	"./ua/Clients.json": [
		3120,
		[
			3120
		]
	],
	"./ua/Dashboard.json": [
		4720,
		[
			4720
		]
	],
	"./ua/Document.json": [
		3761,
		[
			3761
		]
	],
	"./ua/FileNavigator.json": [
		7083,
		[
			7083
		]
	],
	"./ua/ImageEditor.json": [
		52,
		[
			52
		]
	],
	"./ua/Leads.json": [
		4235,
		[
			4235
		]
	],
	"./ua/Objects.json": [
		9720,
		[
			9720
		]
	],
	"./ua/OffCanvasCodeEditor.json": [
		5241,
		[
			5241
		]
	],
	"./ua/Products.json": [
		1200,
		[
			1200
		]
	],
	"./ua/Proposal.json": [
		1622,
		[
			1622
		]
	],
	"./ua/Rate.json": [
		7242,
		[
			7242
		]
	],
	"./ua/Reports.json": [
		2671,
		[
			2671
		]
	],
	"./ua/Services.json": [
		8388,
		[
			8388
		]
	],
	"./ua/Sets.json": [
		4705,
		[
			4705
		]
	],
	"./ua/Settings.json": [
		6269,
		[
			6269
		]
	],
	"./ua/Tariff.json": [
		6670,
		[
			6670
		]
	],
	"./ua/TariffFAQ.json": [
		5246,
		[
			5246
		]
	],
	"./ua/Tasks.json": [
		4250,
		[
			4250
		]
	],
	"./ua/TemplateValueKeys.json": [
		751,
		[
			751
		]
	],
	"./ua/TextFileEditor.json": [
		1528,
		[
			1528
		]
	],
	"./ua/Warehouses.json": [
		9700,
		[
			9700
		]
	],
	"./ua/common.json": [
		2721,
		[
			2721
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;